<template>
  <div class="wrapper">
    <div class="search">
      <div class="search-ipt">
        <div class="search-input">
          <input type="text" placeholder="搜索客户名称" v-model="searchParams.name">
        </div>
        <div class="search-icon" @click="onRefresh">
          搜索
        </div>
      </div>
      <div class="filter-option">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="searchParams.invoiceType"
            :options="invoiceTypeOptions"
            @change="changeType"
          />
          <van-dropdown-item
            v-model="searchOptions.drewDate"
            :options="drewDateOptions"
            @change="changeDrewDate"
          />
        </van-dropdown-menu>
      </div>
    </div>
    <div class="pull-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-swipe-cell
            v-for="(invoice, index) in invoiceList"
            :key="index" :ref="'swipecell'+invoice.id"
            :name="invoice.id"
            :disabled="true"
            :before-close="beforeClose"
            :class="[!cardOpened ? 'swiper-cell-custom-wrp': ''].join(' ')"
          >
            <IncomeCard
              type="income"
              :invoice="invoice"
              :incomeParams="{remark: invoice.remark}"
              @incomeJump="gotoPage(invoice)"
              :btnList="getBtnList(invoice)"
            />
          </van-swipe-cell>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { messageRequest } from '@services'
import IncomeCard from '@components/IncomeCard'
import moment from 'moment'
import {
  DropdownMenu,
  DropdownItem,
  List,
  PullRefresh,
  Notify,
  SwipeCell,
  Button
} from 'vant'
export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    IncomeCard
  },
  props: {},
  data () {
    return {
      drewDateOptions: [
        { text: '寄送日期', value: undefined }
      ],
      searchParams: {
        size: 25,
        current: 1,
        name: '',
        logisticsStatus: 1, // 0 待寄送 1 待签收
        invoiceType: undefined
      },
      invoiceTypeOptions: [
        { text: '全部类型', value: undefined },
        { text: '专票', value: '01' },
        { text: '普票', value: '04' },
        { text: '电子普票', value: '10' },
        { text: '电子专票', value: '08' },
        { text: '卷票', value: '11' },
        { text: '定额发票', value: '200' },
        { text: '火车票', value: '201' },
        { text: '飞机票', value: '202' },
        { text: '出租车票', value: '207' }
      ],
      searchOptions: {
        drewDate: undefined
      },
      invoiceList: [],
      refreshing: false,
      loading: false,
      finished: false,
      cardOpened: false,
      selectCount: 0
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.initDrewDateOptions()
    this.getInvoiceList()
  },
  activated () {},
  updated () {},
  methods: {
    getBtnList (invoice) {
      if (invoice.invoiceType !== '10') {
        return ['express']
      }
      return []
    },
    initDrewDateOptions () {
      let drewDateOptions = [
        { text: '寄送日期', value: undefined }
      ]
      var data = new Date()
      // var year = data.getFullYear()
      data.setMonth(data.getMonth() + 1, 1) // 获取到当前月份,设置月份
      for (var i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        var m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        let value = data.getFullYear() + '-' + (m)
        drewDateOptions.push({ text: value, value: value })
      }
      this.drewDateOptions = drewDateOptions
    },
    async getInvoiceList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const postData = {
        ...this.searchParams
      }
      const data = await messageRequest.todo.getTicketPageByIds(postData)
      if (data.success) {
        if (data.result.records) {
          this.invoiceList = [...this.invoiceList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        Notify({ type: 'danger', message: data.message })
      }

      this.loading = false
    },
    onRefresh () {
      this.finished = false
      this.searchParams.current = 1
      this.cardOpened = false
      this.selectCount = 0
      this.invoiceList = []
      this.getInvoiceList()
    },
    onLoad () {
      this.searchParams.current++
      this.getInvoiceList()
    },
    changeType (value) {
      this.searchParams.changeType = value
      this.onRefresh()
    },
    changeDrewDate (value) {
      if (value) {
        this.searchParams.sendStartTime = moment(value).startOf('month').format('YYYY-MM-DD HH:mm:ss')
        this.searchParams.sendEndTime = moment(value).endOf('month').format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchParams.sendStartTime = ''
        this.searchParams.sendEndTime = ''
      }
      this.onRefresh()
    },
    beforeClose ({ position, instance }) {
      switch (position) {
        case 'left':
          break
      }
    },
    getInvoiceType (invoiceType) { // 获取发票的类型 1增值税票 0非增值税票
      let type = 0
      switch (invoiceType) {
        case '01':
          type = 1
          break
        case '04':
          type = 1
          break
        case '10':
          type = 1
          break
        case '11':
          type = 1
          break
        case '200':
          type = 0
          break
        case '201':
          type = 0
          break
        case '202':
          type = 0
          break
        case '207':
          type = 0
          break
        default:
          break
      }
      return type
    },
    gotoPage (params) {
      let type = this.getInvoiceType(params.invoiceType)
      this.$router.push(`/invoice/income/invoice?id=${params.id}&type=${type}`)
    }
  }
}
</script>
<style lang="less" scoped src="../UnSendInvoice/style.less"/>
